import { Button, ClickAwayListener } from '@mui/material';
import { RoutalPalette, RoutalTooltip, RoutalTooltipPlacementTypes } from '@nx-smartmonkey/ui';
import { useState } from 'react';

type TooltipProps = {
  id?: string;
  title: string | React.ReactElement;
  placement?: RoutalTooltipPlacementTypes;
  overlayStyle?: React.CSSProperties;
  overlayInnerStyle?: React.CSSProperties;
  backgroundColor?: string;
  contentStyles?: React.CSSProperties;
  arrowColor?: string;
  visible?: boolean;
};

export const Tooltip = ({
  id,
  children,
  title,
  placement = `top`,
  overlayStyle = {},
  overlayInnerStyle = {},
  contentStyles = {},
  backgroundColor = RoutalPalette.neutral60,
  visible = true,
}: React.PropsWithChildren<TooltipProps>) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <RoutalTooltip
        id={id}
        title={title}
        placement={placement}
        overlayStyle={overlayStyle}
        overlayInnerStyle={overlayInnerStyle}
        contentStyles={contentStyles}
        backgroundColor={backgroundColor}
        visible={visible}
        disableFocusListener={true}
        disableHoverListener={true}
        disableTouchListener={true}
        open={open}
      >
        <Button onClick={handleTooltipOpen} style={{ minWidth: 0, padding: 0, margin: `7px` }}>
          {children}
        </Button>
      </RoutalTooltip>
    </ClickAwayListener>
  );
};
